import { getOrderDelivery } from "apis/deliveryApi";
import { doCall } from "common/genericSaga";
import { call, put, takeEvery } from "redux-saga/effects";
import { DELIVERY_REQUESTED, DELIVERY_REQUEST_FAILED, receiveOrderDelivery } from "./deliveryActions";

export function* doRequestDeliveryInfo(action, requestInfo) {
  const delivery = yield call(getOrderDelivery, requestInfo, action.id);
  yield put(receiveOrderDelivery(action.id, delivery));
}

export function* watchDelivery() {
  yield takeEvery(DELIVERY_REQUESTED, doCall(doRequestDeliveryInfo, DELIVERY_REQUEST_FAILED));
}
